import { render, staticRenderFns } from "./ServerRadioComp.vue?vue&type=template&id=bccef7ea&scoped=true&"
import script from "./ServerRadioComp.vue?vue&type=script&lang=js&"
export * from "./ServerRadioComp.vue?vue&type=script&lang=js&"
import style0 from "./ServerRadioComp.vue?vue&type=style&index=0&id=bccef7ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bccef7ea",
  null
  
)

export default component.exports